export default __webpack_public_path__ + "static/media/nft-11.482003fd.png";